<template>
	<!-- 이력서 등록요청 팝업 -->
	<div class="notice_popup view">
		<div class="close" @click="$emit('close')">
			<img src="/images/close.png" alt="닫기"/>
		</div>
		<div class="view-tit">
			<span>{{param.mberNm}} / {{param.loginId}}</span>
		</div>
		<div class="listArea">
			<div class="Board type3">
				<table class="Board_type3 admin other">
					<colgroup>
						<col width="5%">
						<col width="13%">
						<col width="60%">
						<col width="22%">
					</colgroup>
					<thead>
						<tr>
							<th>NO</th>
							<th>날짜</th>
							<th>파일명</th>
							<th>다운로드</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(file, idx) in fileList" :key="idx">
							<td class="score">{{((pageInfo.pageIndex - 1) * 10) + (idx + 1)}}</td>
							<td class="score">{{file.regDate}}</td>
							<td class="score"><InputComp title="파일명" classNm="fileName" :readonly="true" v-model="file.orgFileNm"/></td>
							<td class="score">
								<img :src="'/images/admin/btn_resume_down_'+file.downBtnImg+'.png'" style="vertical-align: middle; cursor: pointer;" @click="fileDown(file)">
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- 페이징부분 -->
			<paging-comp :pageInfo="pageInfo" @page-click="goPage"/>
		</div>
	</div>
</template>
<script>
import pagingComp from '@/components/PagingComp.vue';
export default {
	components: { pagingComp },
	props: { param:Object },
	data() {
		return {
			data: {},

			inqCond: {},
			fileList: [],
			pageInfo : {},
		};
	},
	mounted(){
		// this.$.httpPost('/api/mem/prf/getTecSummary', {tecMberSeq : this.param.tecMberSeq})
		// 	.then(res => {
		// 		this.data = res.data;	
		// 	}).catch(this.$.httpErrorCommon);

		this.inqCond.tecMberSeq = this.param.mberSeq;
		this.getResmAtchFiles();
	},
	methods: {
		getResmAtchFiles() {
			this.$.httpPost('/api/mem/adm/prf/getResmAtchFileList', this.inqCond)
				.then(res => {
					// console.log('data', res.data);
					
					this.data = res.data;
					this.fileList = res.data.list;
					this.pageInfo = res.data.pageInfo;

					// console.log('pageInfo', this.pageInfo);
				}).catch(this.$.httpErrorCommon);
		},

		goPage(page){
			this.inqCond.pageIndex = page;
			this.getResmAtchFiles();
		},

		fileDown(file) {
			var param = {
				tecMberSeq : this.inqCond.tecMberSeq,
				attaFileSeq: file.attaFileSeq
			}

			this.$.fileDownload('/api/mem/adm/prf/downResmAgncFile', param, {}, 'POST', true)
					.then(()=> {
						this.getResmAtchFiles();
					})
					.catch(this.$.httpErrorCommon);
		}
	},
};
</script>
